/* eslint-disable consistent-return */
/* eslint-disable no-unreachable */
/* eslint-disable no-unused-vars */
/* eslint-disable react/no-unused-state */
/* eslint-disable no-console */

/* eslint-disable no-unused-vars */
import React, { useState, useReducer, useEffect } from 'react';
// import Container from 'react-bootstrap/Container';
// import ReactHtmlParser from 'react-html-parser';
import Moment from 'moment';
import { extendMoment } from 'moment-range';
import ReactHtmlParser from 'react-html-parser';
import { prepareData } from '../../utils/calculate';

// eslint-disable-next-line no-unused-vars
import formcss from './form.css';
import LoadSpinner from '../../components/loadspinner/loadspinner';

import { QUESTIONS } from '../../constants.jsx';
import {
  initialState,
  reducer,
  RESET,
  UPDATE_DAY_DATA,
  QUESTION_0_FINISH,
  QUESTION_1_FINISH,
  QUESTION_2_FINISH,
  QUESTION_2_BACK,
  QUESTION_3_FINISH,
  QUESTION_3_BACK,
  QUESTION_3_RELOAD,
  QUESTION_4_FINISH,
  QUESTION_4_BACK,
  RESULTS_BACK,
} from './reducer';
import { StoreContext } from '../../utils/store';

import {
  Question0,
  Question1,
  Question2,
  Question3,
  Question4,
  Results,
} from '../questions';

// eslint-disable-next-line no-unused-vars
const moment = extendMoment(Moment);

const Form = props => {
  const { calcData } = { ...props };

  const {
    dayData: [dayData, setDayData],
    incurredDate,
    incurredAmount,
    paymentFrequency,
    paymentFrequencyStartDate,
    paymentFrequencyAmount,
    finalPaymentDate,
    installments,
  } = React.useContext(StoreContext);

  const [state, dispatch] = useReducer(reducer, initialState);
  const minDate = new Date('01/01/2007');

  useEffect(() => {
    const data = prepareData(calcData);
    dispatch({ type: UPDATE_DAY_DATA, payload: { dayData: data } });
  }, []);

  const resetAll = () => {
    incurredDate[1](undefined);
    incurredAmount[1]('');
    installments[1]([]);
    paymentFrequency[1](undefined);
    paymentFrequencyStartDate[1](undefined);
    paymentFrequencyAmount[1](undefined);
    finalPaymentDate[1](undefined);
  };

  const { currentQuestionNum, loading } = { ...state };

  const questionMap = [
    {
      component: Question0,
      props: {
        content: ReactHtmlParser(calcData.content),
        onFinish: payload => dispatch({ type: QUESTION_0_FINISH, payload }),
      },
    },
    {
      component: Question1,
      props: {
        incurredDate,
        incurredAmount,
        finalPaymentDate,
        minDate,
        question1HelpText: ReactHtmlParser(calcData.question1HelpText),
        onFinish: payload => dispatch({ type: QUESTION_1_FINISH, payload }),
        onReset: () => {
          resetAll();
          dispatch({ type: RESET });
        },
      },
    },
    {
      component: Question2,
      props: {
        installments,
        incurredDate,
        incurredAmount,
        finalPaymentDate,
        question2HelpText: ReactHtmlParser(calcData.question2HelpText),
        onFinish: payload => dispatch({ type: QUESTION_2_FINISH, payload }),
        onBack: () => dispatch({ type: QUESTION_2_BACK }),
      },
    },
    {
      component: Question3,
      props: {
        todaysDateString: Moment().format('DD/MM/YYYY'),
        amountRemainingToday: state.amountRemainingToday,
        interestRemainingToday: state.interestRemainingToday,
        futureDisclaimer: ReactHtmlParser(calcData.futureDisclaimer),
        question3HelpText: ReactHtmlParser(calcData.question3HelpText),
        incurredDate,
        incurredAmount,
        finalPaymentDate,
        hasInstallments: installments[0].length > 0,
        disclaimer: ReactHtmlParser(calcData.disclaimer),
        onFinish: payload => dispatch({ type: QUESTION_3_FINISH, payload }),
        onBack: () => dispatch({ type: QUESTION_3_BACK }),
        onReset: () => {
          resetAll();
          dispatch({ type: RESET });
        },
      },
    },
    {
      component: Question4, // No longer used
      props: {
        onFinish: payload => dispatch({ type: QUESTION_4_FINISH, payload }),
        onBack: () => dispatch({ type: QUESTION_4_BACK }),
        incurredDate,
        incurredAmount,
        paymentFrequency,
        paymentFrequencyAmount,
        paymentFrequencyStartDate,
      },
    },
    {
      component: Results,
      props: {
        payments: state.payments,
        incurredAmount,
        incurredDate,
        finalPaymentDate,
        disclaimer: ReactHtmlParser(calcData.disclaimer),
        onReset: () => {
          resetAll();
          dispatch({ type: RESET });
        },
        onBack: () => dispatch({ type: RESULTS_BACK }),
      },
    },
  ];

  const current = questionMap[currentQuestionNum];
  const Question = current.component;
  // eslint-disable-next-line react/jsx-props-no-spreading
  const instantiatedQuestion = <Question {...current.props} />;
  const [show, setShow] = useState(true);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  return (
    <>
      {/* {loading ? <LoadSpinner /> : null} */}
      <div className="form debt-calculator">{instantiatedQuestion}</div>
    </>
  );
};

export default Form;
